import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import reducers from "./modules";
import reactotron from "./reactotron";

const enhancers = [applyMiddleware(thunk)];

if (__DEV__) {
  console.r.log("Reactron Configured");
  enhancers.push(reactotron.createEnhancer());
}

export const store = createStore(reducers, compose(...enhancers));

const State = ({ children }) => <Provider store={store}>{children}</Provider>;

export default State;
